import { useMemo } from 'react';

// material-ui
import { Box, Typography, useMediaQuery } from '@mui/material';
import useUserData from "../../../../../hooks/user/useUserData";
import AccountMenu from "../../../accountMenu/accountMenu";
import LanguageSelect from "../../../languageSelect/languageSelect";
// project import

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
	const downSM = useMediaQuery((theme) => theme.breakpoints.down('sm'))
	const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'))
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const localization = useMemo(() => <LanguageSelect color={'#000000'}/>, []);
	const { username } = useUserData()
	return (
		<>
			{!downSM && <Box sx={{ ml: 'auto' }}/>}
			{!downMD && (
				<Typography variant="caption" color="secondary" sx={{fontWeight: 'bold'}}>
					{username}
				</Typography>
			)}
			<Box sx={{ display: 'flex', gap: downSM ? '2px' : '32px' }}>
				{localization}
				<AccountMenu/>
			</Box>
		</>
	);
};

export default HeaderContent;
